import React, { useEffect, useState, useRef, useCallback } from "react";
import * as signalR from '@microsoft/signalr';
import LauritzKnudsenLogo from "../images/LK_Digital Logo.png";
import SmartcommLogo from "../images/Smartcommlogo.png";
import User from "../images/User.svg";
import "../cssfiles/homepage.css";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import AppsRoundedIcon from "@mui/icons-material/AppsRounded";
import {
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Box,
  Tooltip,
  Dialog,
  DialogContent,
} from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useDispatch, useSelector } from "react-redux";
import { updatelogindetails } from "../store/login_data";
//import MenuIconrounded from '../images/MenuIconrounded.svg';
import { getalarms, user,  } from "../Restclient/datacollection";
import { updatelatestalarm } from "../store/alarm_data";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { theme } from "antd";
import LK_User from "../images/LK_User.js";
import LK_Settings from "../images/LK_Settings.js";
import LK_LogOut from "../images/LK_LogOut.js";
import { Padding } from "@mui/icons-material";
import { ReactComponent as MenuIconrounded } from "../images/MenuIconrounded.svg";
import { getorganizationtree } from "../Restclient/datacollection";
import { baseURL } from "../Restclient/datacollection";
import { setOrganizationtree } from "../store/cofig_data";
import { updatealarmarray } from "../store/alarm_data";
import {
  getDeviceTagMapping,
  getDeviceTagMappingToastMessage,
  getalarmeventsrecords,
  acknowledgealarmeventrecord,
  userLogout,
  livedata,
} from "../Restclient/datacollection";
import { updatelivedata1, updateliveoverviewdata, updatelivedata } from "../store/mainpage_data";
import LK_File from "../images/LK_File.js";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { Switch as AntdSwitch } from "antd";
import { ConfigProvider } from "antd";
import { updatetheme } from "../store/theme_data.js";
import { useNavigate } from "react-router-dom";
import { clearLoginData } from "../store/login_data";
import { useAuth0 } from "@auth0/auth0-react";
import CustomButton from "./CommonComponents/CustomButton.jsx";
import CustomCancelButton from "./CommonComponents/CustomCancelButton.jsx";
import CustomLabel from "./CommonComponents/CustomLabel.jsx";
import OperateLogo from "../images/operate-logo.jpg";
import LK_Info from "../images/LK_Info.js";

export default function Mainheader() {
  const { logout } = useAuth0();
  const [toggleval, setToggleval] = useState(false);
  const userToken = sessionStorage.getItem("Token");
  const handlethemetoggel = (checked) => {
    if (checked) {
      setToggleval(checked);
      dispatch(updatetheme("dark"));
    } else {
      setToggleval(checked);
      dispatch(updatetheme("light"));
    }
  };

  useEffect(() => {
    if (themechange === "dark") {
      setToggleval(true);
    } else {
      setToggleval(false);
    }
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const username = useSelector((state) => state.logindata.userdetails.UserName);
  const themechange = useSelector((state) => state.themedata.theme);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const [anchorE1, setAnchorE1] = useState(null);
  const [opensnack, setOpensnack] = React.useState(false);
  const [alarmcolor, setAlarmcolor] = useState("#DC272D");
  const [allalarms, setAllAlarms] = useState([]);
  const [newalarms, setNewAlarms] = useState([]);
  const [openSnackbars, setOpenSnackbars] = useState([]);
  const userdetails = useSelector((state) => state.logindata.userdetails);

  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );

  const [popup, setPopup] = useState(false);
  const handleClosePopup = (event, reason) => {
    if (reason === "closeButton") {
      setPopup(false);
    }
  };

  const selectedprojectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const previousselectedprojectname = useSelector(
    (state) => state.mainpagedata.previousselectedprojectname
  );
  const livealarmarray = useSelector((state) => state.alarmdata.livealarmarray);
  const livealarmRef = useRef(livealarmarray);

  useEffect(() => {
    livealarmRef.current = livealarmarray; // Always keep ref updated
  }, [livealarmarray]);

  const handleCloseToast = (index) => (event, reason) => {
    if (reason === "clickaway") return;

    setOpenSnackbars((prevOpen) => {
      const updatedOpen = [...prevOpen];
      updatedOpen[index] = false; // Close the specific snackbar
      return updatedOpen;
    });
  };

  const [tagDeviceMappings, settagDeviceMappings] = useState({});

  
  // Live data polling logic
  const intervalref = useRef();

  const livedatacallback = (res) => {
    var datajson = JSON.parse(res.data.data);
    var overviewjson = res.data.overviewParameterDataMap;
    dispatch(updateliveoverviewdata(overviewjson));
    // console.log("Live data received in Mainheader:",res.data, datajson);
    dispatch(updatelivedata(datajson));
  };

  const timerfunction = () => {
    livedata(livedatacallback);
  };

  // Start live data polling on mount
  useEffect(() => {
    livedata(livedatacallback);
    var intervalId = setInterval(timerfunction, 60000);
    intervalref.current = intervalId;

    return () => {
      if (intervalref.current !== null) {
        clearInterval(intervalref.current);
      }
    };
  }, []);
  
  //ALERTS SPECIFIC IMPLEMENTATION
  const [connection, setConnection] = useState(null);
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const [userId, setUserId] = useState('');
  const [currentGroup, setCurrentGroup] = useState('');
  const [messageInput, setMessageInput] = useState('');
  const [groupInput, setGroupInput] = useState('');
  const [userInput, setUserInput] = useState('');
  const [targetUserInput, setTargetUserInput] = useState('');
  const [connectionInfo, setConnectionInfo] = useState(null);
  const [status, setStatus] = useState('Disconnected');
  const [lastError1, setLastError1] = useState('');
  const [groups, setGroups] = useState({});
  const [serverHealth, setServerHealth] = useState(null);
  const messagesEndRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const autoConnectAttempted = useRef(false);
  const autoJoinAttempted = useRef(false);
  const [onlyFirstRender, setOnlyFirstRender] = useState(false);
  const tagdetails = useSelector((state) => state.mainpagedata.tagdetailsobject)
  const API_BASE_URL = baseURL;

  // Configuration for auto-connect and auto-join
//   const AUTO_CONNECT_CONFIG = {
//     enabled: true,                    // Set to false to disable auto-connect
//     defaultUserId: userToken,               // Leave empty for auto-generated, or set a specific user ID
//     autoJoinGroup: userdetails.Projectid,   // Set to null/empty to disable auto-join, or specify group name
//     connectDelay: 1000,              // Delay before auto-connect (ms)
//     joinDelay: 2000                  // Delay after connection before auto-join (ms)
//   };

// Add this helper function near the top of your component, after the state declarations
const hasSignalRPermission = () => {
  return Array.isArray(userdetails?.PermissionsArray) && 
         userdetails.PermissionsArray.length > 0 && 
         userdetails.PermissionsArray.includes("PALV67");
};

const scrollToBottom = useCallback(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, scrollToBottom]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (connection) {
        connection.stop();
      }
    };
  }, [connection]);

  // Auto-connect effect - runs once on component mount
  useEffect(() => {
      
    if (AUTO_CONNECT_CONFIG.enabled && !autoConnectAttempted.current && !isConnecting && !isConnected) {
      autoConnectAttempted.current = true;
      
      const autoConnect = async () => {
        try {
          addMessage('🤖 Auto-connecting in 1 second...', 'info');
          
          // Set the user ID if provided in config
          if (AUTO_CONNECT_CONFIG.defaultUserId) {
            setUserInput(AUTO_CONNECT_CONFIG.defaultUserId);
          }
          
          await new Promise(resolve => setTimeout(resolve, AUTO_CONNECT_CONFIG.connectDelay));
          await connectToSignalR();
        } catch (error) {
          console.error('Auto-connect failed:', error);
          addMessage(`❌ Auto-connect failed: ${error.message}`, 'error');
        }
      };

      autoConnect();
    }
  }, []); // Empty dependency array - runs only once on mount

//   // Auto-join group effect - runs when connection is established
//   useEffect(() => {
//     if (isConnected && 
//         AUTO_CONNECT_CONFIG.autoJoinGroup && 
//         !autoJoinAttempted.current && 
//         !currentGroup) {
      
//           console.log("Auto-join group effect triggered-isConnected",isConnected,"AUTO_CONNECT_CONFIG.autoJoinGroup",AUTO_CONNECT_CONFIG.autoJoinGroup,"autoJoinAttempted.current",autoJoinAttempted.current,"currentGroup",currentGroup);
//       autoJoinAttempted.current = true;
      
//       const autoJoinGroup = async () => {
//         try {
//           addMessage(`🤖 Auto-joining group "${AUTO_CONNECT_CONFIG.autoJoinGroup}" in 2 seconds...`, 'info');
          
//           await new Promise(resolve => setTimeout(resolve, AUTO_CONNECT_CONFIG.joinDelay));
          
//           // Set the group input and join
//           setGroupInput(AUTO_CONNECT_CONFIG.autoJoinGroup);
//           await joinGroup(AUTO_CONNECT_CONFIG.autoJoinGroup);
//         } catch (error) {
//           console.error('Auto-join group failed:', error);
//           addMessage(`❌ Auto-join group failed: ${error.message}`, 'error');
//         }
//       };

//       autoJoinGroup();
//     }
    
    
//   }, [isConnected]); // Runs when isConnected changes to true
// ✅ ADD: Dynamic auto-join group calculation
  const getAutoJoinGroup = () => {
    const userProjectId = userdetails?.Projectid;
    
    if (userProjectId && userProjectId !== 'All') {
      return userProjectId;
    } else if (userProjectId === 'All' && selectedprojectname && selectedprojectname !== 'All') {
      return selectedprojectname;
    }
    
    return null; // No group to join
  };

  // ✅ UPDATED: Configuration with dynamic group selection
  const AUTO_CONNECT_CONFIG = {
    enabled: hasSignalRPermission(),
    defaultUserId: userToken,
    autoJoinGroup: getAutoJoinGroup(), // ✅ Dynamic calculation
    connectDelay: 1000,
    joinDelay: 2000
  };

  // ... all your existing functions remain exactly the same until here...

  // ✅ UPDATED: Auto-join group effect with new dependencies
  useEffect(() => {
    if (isConnected && 
        getAutoJoinGroup() && // ✅ Use dynamic function
        !autoJoinAttempted.current && 
        !currentGroup) {
      
      const targetGroup = getAutoJoinGroup();
      // console.log("Auto-join group effect triggered", {
      //   isConnected,
      //   targetGroup,
      //   userProjectId: userdetails?.Projectid,
      //   selectedProject: selectedprojectname,
      //   autoJoinAttempted: autoJoinAttempted.current,
      //   currentGroup
      // });
      
      autoJoinAttempted.current = true;
      
      const autoJoinGroup = async () => {
        try {
          addMessage(`🤖 Auto-joining group "${targetGroup}" in 2 seconds...`, 'info');
          
          await new Promise(resolve => setTimeout(resolve, AUTO_CONNECT_CONFIG.joinDelay));
          
          setGroupInput(targetGroup);
          await joinGroup(targetGroup);
        } catch (error) {
          console.error('Auto-join group failed:', error);
          addMessage(`❌ Auto-join group failed: ${error.message}`, 'error');
        }
      };

      autoJoinGroup();
    }
  }, [isConnected, userdetails?.Projectid, selectedprojectname]); // ✅ Added dependencies

  // ✅ NEW: Handle project changes for auto group switching
  useEffect(() => {
    const handleProjectChange = async () => {
      if (!isConnected || !userId) return;

      const targetGroup = getAutoJoinGroup();
      
      // console.log("Project change detected:", {
      //   userProjectId: userdetails?.Projectid,
      //   selectedProject: selectedprojectname,
      //   targetGroup,
      //   currentGroup,
      //   shouldSwitch: targetGroup !== currentGroup
      // });

      // Only switch if target group is different from current
      if (targetGroup && targetGroup !== currentGroup) {
        try {
          // Leave current group if in one
          if (currentGroup) {
            console.log(`Leaving current group: ${currentGroup}`);
            await makeApiCall('/alarmsSignalR/api/group/remove', {
              userId: userId,
              groupName: currentGroup
            });
            addMessage(`🚪 Left group: ${currentGroup}`, 'success');
          }

          // Join new target group
          console.log(`Joining new group: ${targetGroup}`);
          await makeApiCall('/alarmsSignalR/api/group/add', {
            userId: userId,
            groupName: targetGroup
          });
          
          setCurrentGroup(targetGroup);
          addMessage(`🚪 Joined group: ${targetGroup}`, 'success');
          
          // Log reason for joining
          let reason = '';
          if (userdetails && typeof userdetails.Projectid !== 'undefined' && userdetails.Projectid !== null) {
            if (userdetails.Projectid !== 'All') {
              reason = `user project "${userdetails.Projectid}"`;
            } else {
              reason = `selected project "${selectedprojectname}" (user has All access)`;
            }
          } else {
            reason = 'unknown project (userdetails or Projectid missing)';
          }
          addMessage(`📋 Joined based on ${reason}`, 'info');
          
        } catch (error) {
          console.error('Failed to switch groups:', error);
          addMessage(`❌ Failed to switch groups: ${error.message}`, 'error');
        }
      } else if (!targetGroup && currentGroup) {
        // Leave group if no target group needed
        try {
          await makeApiCall('/alarmsSignalR/api/group/remove', {
            userId: userId,
            groupName: currentGroup
          });
          setCurrentGroup('');
          addMessage(`🚪 Left group: ${currentGroup} (no target group)`, 'success');
        } catch (error) {
          console.error('Failed to leave group:', error);
        }
      }
    };

    // Only run if connected and have userId
    if (isConnected && userId) {
      handleProjectChange();
    }
  }, [userdetails?.Projectid, selectedprojectname, isConnected, userId]); 

  useEffect(()=>{
      if(Array.isArray(userdetails?.PermissionsArray) && 
         userdetails.PermissionsArray.length > 0){
                 if(userdetails.PermissionsArray.includes("PJGF26") && userdetails.PermissionsArray.includes("PJDF29")){
                      getDeviceTagMappingToastMessage(getDeviceTagMappingcallback);
                 }
                 if(userdetails.PermissionsArray.includes("USCR06")  || userdetails.PermissionsArray.includes("PJCR05") || userdetails.PermissionsArray.includes("OGCR03")){
                    getorganizationtree(orgtreecallback)
                 }
         } 
        
        
        if (hasSignalRPermission()) {
            // Ensure userdetails and Projectid are defined
            if (userdetails && typeof userdetails.Projectid !== 'undefined' && userdetails.Projectid !== null) {
                 if(userdetails?.Projectid == "All"){
                      if (typeof selectedprojectname !== 'undefined' && selectedprojectname !== null && selectedprojectname !== "") {
                          if(userdetails.PermissionsArray.includes("PALV67")){
                               getalarmeventsrecords(selectedprojectname, alarmrecordscallback);
                          }
                         
                      } else {
                          dispatch(updatealarmarray([]));
                      }

                      if(userdetails.PermissionsArray.includes("PALV67")){
                          getalarmeventsrecords(selectedprojectname,alarmrecordscallback)
                      }
                  }else{
                    if(userdetails.PermissionsArray.includes("PALV67")){
                        getalarmeventsrecords(userdetails.Projectid,alarmrecordscallback)
                    }
                  }
            } else {
                dispatch(updatealarmarray([]));
            }

           
        }else{
            dispatch(updatealarmarray([]))
        }
        
       
        // Set isRendered to true after data is fetched
    
  },[selectedprojectname])

  // Reset auto-attempt flags when disconnected
  // UPDATED: Reset auto-attempt flags when disconnected or projects change
  useEffect(() => {
    if (!isConnected) {
      autoJoinAttempted.current = false;
      setCurrentGroup(''); // Clear current group on disconnect
    }
  }, [isConnected]);

  // ✅ UPDATED: Reset auto-join flag when projects change to allow re-joining
  useEffect(() => {
    if (isConnected) {
      autoJoinAttempted.current = false; // Allow re-joining when projects change
    }
  }, [userdetails?.Projectid, selectedprojectname]);

  // ... all your existing functions (joinGroup, leaveGroup, etc.) remain exactly the same ...

  // ✅ OPTIONAL: Enhanced status display (minimal change)
  const getGroupStatus = () => {
    const targetGroup = getAutoJoinGroup();
    const userProjectId = userdetails?.Projectid;
    
    if (!currentGroup) return { text: 'None', color: 'text-gray-500' };
    
    if (userProjectId !== 'All' && currentGroup === userProjectId) {
      return { text: `${currentGroup} (User Project)`, color: 'text-blue-600' };
    } else if (userProjectId === 'All' && currentGroup === selectedprojectname) {
      return { text: `${currentGroup} (Selected - All Access)`, color: 'text-green-600' };
    } else {
      return { text: `${currentGroup} (Manual)`, color: 'text-orange-600' };
    }
  };

  // Check server health on component mount
  useEffect(() => {
    if (hasSignalRPermission()) {
        checkServerHealth();
    }
  }, []);

  // Add message to the message list
  const addMessage = useCallback((message, type = 'info') => {
    const newMessage = {
      id: `${Date.now()}-${Math.random()}`,
      text: typeof message === 'string' ? message : JSON.stringify(message, null, 2),
      type: type,
      timestamp: new Date().toLocaleTimeString()
    };
    setMessages(prev => [...prev.slice(-99), newMessage]); // Keep last 100 messages
  }, []);

  // Clear error after some time
  useEffect(() => {
    if (lastError1) {
      const timer = setTimeout(() => setLastError1(''), 10000);
      return () => clearTimeout(timer);
    }
  }, [lastError1]);

  // Check server health
  const checkServerHealth = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/health`);
      if (response.ok) {
        const health = await response.json();
        setServerHealth(health);
        addMessage(`Server health: ${health.status} - ${health.messagesInStore} messages stored`, 'info');
      }
    } catch (error) {
      console.error('Health check failed:', error);
      setServerHealth({ status: 'error', error: error.message });
    }
  };

  // Load groups information
  const loadGroups = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/alarmsSignalR/api/groups`);
      if (response.ok) {
        const data = await response.json();
        setGroups(data.groups);
        addMessage(`Loaded ${data.totalGroups} groups with ${data.totalUsers} total users`, 'info');
      }
    } catch (error) {
      console.error('Failed to load groups:', error);
    }
  };

  // Negotiate connection with backend
  const negotiateConnection = async () => {
    try {
      setLastError1('');
      const response = await fetch(`${API_BASE_URL}/alarmsSignalR/api/negotiate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: userInput.trim() || undefined })
      });

      console.log("AZURE SIGNALR STEP2: negotiateConnection called-response",response);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log("AZURE SIGNALR STEP4: negotiateConnection called-response.json -data",data);
      setConnectionInfo(data);
      setUserId(data.userId);
      addMessage(`Negotiated connection for user: ${data.userId}`, 'info');
      return data;
    } catch (error) {
      console.error('Negotiation failed:', error);
      const errorMsg = `Negotiation failed: ${error.message}`;
      addMessage(errorMsg, 'error');
      setLastError1(errorMsg);
      throw error;
    }
  };

  // Connect to SignalR
  const connectToSignalR = async () => {
    // Check permission before connecting
    if (!hasSignalRPermission()) {
        const errorMsg = 'Connection denied: PALV67 permission required for real-time alerts';
        addMessage(`❌ ${errorMsg}`, 'error');
        setLastError1(errorMsg);
        return;
    }
    
    if (isConnecting || isConnected) return;
    console.log("AZURE SIGNALR STEP1: connectToSignalR called");
    try {
      setIsConnecting(true);
      setStatus('Negotiating...');
      setLastError1('');
      
      const connInfo = await negotiateConnection();
      setStatus('Connecting...');

      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(connInfo.url, {
          accessTokenFactory: () => connInfo.accessToken,
          transport: signalR.HttpTransportType.ServerSentEvents,
          skipNegotiation: false
        })
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: retryContext => {
            if (retryContext.elapsedTime < 60000) {
              return Math.random() * 10000;
            } else {
              return null;
            }
          }
        })
        .configureLogging(signalR.LogLevel.Information)
        .build();

      console.log("AZURE SIGNALR STEPN:Connecting...newConnection",newConnection)

      // Set up event handlers
      newConnection.on('ReceiveMessage', (message) => {
        console.log("Raw message received in ReceiveMessage handler:", message, typeof message);
          //addMessage(`📨 Received: ${JSON.stringify(message, null, 2)}`, 'received');
          // const newAlert = JSON.parse(message);
          // const newAlarmsArray = [...livealarmarray, newAlert];

          // const ToastMessage = [];
          // ToastMessage.push(newAlert);
          // setNewAlarms(ToastMessage);
          
          // dispatch(updatelatestalarm(newAlarmsArray));
          try {
              console.log("Raw message received:", message, typeof message);
              addMessage(`📨 Received: ${JSON.stringify(message, null, 2)}`, 'received');
              
              // Fix: message is already a JavaScript object
              const newAlert = message?.alerts;
              const type = message?.type || 'UPDATE';
              console.log("AZURE SIGNALR STEP5: ReceiveMessage called-newAlert", newAlert);
              
             // Validate the alert object
              if (newAlert && (newAlert.AlertID || newAlert.TagID)) {
                  //Fix: Ensure livealarmarray is always an array
                  console.log("AZURE SIGNALR STEP6: ReceiveMessage called-livealarmarray", livealarmarray,"newAlert",newAlert);
                  const currentAlarms = livealarmRef.current; 

                  if(type === "NEW"){
                      let newAlarmsArray = [newAlert, ...currentAlarms ];  // New array
                      newAlarmsArray = newAlarmsArray.slice(0, 100);

                      // Update Redux store with the new alarms array
                      dispatch(updatealarmarray(newAlarmsArray));

                      // Show toast notification for the new alert
                      const ToastMessage = [newAlert];
                      setNewAlarms(ToastMessage);
                      
                      // Open snackbar for the new alert
                      setOpenSnackbars([true]);
                      //console.log("New alert added and toast notification triggered:", newAlert.AlertID);
                  }

                   if (type === "UPDATE") {
                      // ✅ Create new array with updated alert (immutable)
                      // let updatedAlarmsArray = currentAlarms.map(alarm => {
                      //   if (alarm.AlertID === newAlert.AlertID) {
                      //     console.log("Alert updated:", newAlert);
                      //     return { ...alarm, ...newAlert }; // Merge old and new data
                      //   }
                      //   return alarm; // Keep unchanged alerts as-is
                      // });
                      let updatedAlarmsArray = currentAlarms.filter(alarm => {
                          if (alarm.AlertID === newAlert.AlertID) {
                            if (alarm.AcknowledgementStatus == "true" || alarm.AcknowledgementStatus == true) {
                              // Drop this alarm (do not include in array)
                              return false;
                            } else {
                              // Replace with updated alert
                              return true;
                            }
                          }
                          return true; // Keep all other alarms
                        }).map(alarm => {
                          // Update the matching alert if not dropped
                          if (alarm.AlertID === newAlert.AlertID && alarm.State !== "inactive") {
                            //console.log("Alert updated:", newAlert);
                            return { ...alarm, State: "inactive" };
                          }
                          return alarm;
                        });
                      console.log("AZURE SIGNALR STEP7: ReceiveMessage called-updatedAlarmsArray before slice", updatedAlarmsArray);
                      // ✅ Check if any alert was actually updated
                      const wasUpdated = updatedAlarmsArray.some((alarm, index) => 
                        alarm !== currentAlarms[index]
                      );
                      
                      if (!wasUpdated) {
                        console.warn("No alert found to update with AlertID:", newAlert.AlertID);
                        return; // Don't dispatch if nothing changed
                      }else{
                        // Update Redux store with the new alarms array
                        dispatch(updatealarmarray(updatedAlarmsArray));
                      }
                    }
                 
               
              } else {
                console.warn("Received invalid alert format:", newAlert);
              }
            
          } catch (error) {
            console.error("Error in ReceiveMessage handler:", error);
            addMessage(`❌ Error processing alert: ${error.message}`, 'error');
            // Don't re-throw to prevent connection closure
          }
      });

      newConnection.on('messageReceived', (message) => {
        addMessage(`📨 Legacy Message: ${JSON.stringify(message, null, 2)}`, 'received');
      });

      newConnection.on('GroupMessage', (message) => {
        addMessage(`👥 Group Message: ${JSON.stringify(message, null, 2)}`, 'group');
      });

      newConnection.on('UserMessage', (message) => {
        addMessage(`👤 Direct Message: ${JSON.stringify(message, null, 2)}`, 'direct');
      });

      newConnection.onreconnecting((error) => {
        setStatus('Reconnecting...');
        setIsConnected(false);
        addMessage('🔄 Connection lost, reconnecting...', 'warning');
      });

      newConnection.onreconnected((connectionId) => {
        setStatus('Connected');
        setIsConnected(true);
        addMessage(`✅ Reconnected! Connection ID: ${connectionId?.substring(0, 8)}...`, 'success');
      });

      newConnection.onclose((error) => {
        console.log('Connection closed:', error);
        setStatus('Disconnected');
        setIsConnected(false);
        setConnection(null);
        const errorMsg = error ? `Connection closed: ${error}` : 'Connection closed';
        addMessage(`❌ ${errorMsg}`, 'error');
        if (error) {
          setLastError1(errorMsg);
        }
      });

      await newConnection.start();
      
      setConnection(newConnection);
      setIsConnected(true);
      setStatus('Connected');
      addMessage(`🎉 Connected to SignalR! User: ${connInfo.userId}`, 'success');
      
      // // Load groups after connection
      // await loadGroups();
      
    } catch (error) {
      console.error('SignalR connection failed:', error);
      const errorMsg = `Connection failed: ${error.message}`;
      setStatus('Connection Failed');
      setLastError1(errorMsg);
      addMessage(`❌ ${errorMsg}`, 'error');
    } finally {
      setIsConnecting(false);
    }
  };

  // Disconnect from SignalR
  const disconnect = async () => {
    if (connection) {
      try {
        await connection.stop();
        setConnection(null);
        setIsConnected(false);
        setStatus('Disconnected');
        setCurrentGroup('');
        addMessage('👋 Disconnected from SignalR', 'info');
        
        // Reset auto-attempt flags to allow auto-connect on next mount if needed
        autoConnectAttempted.current = false;
        autoJoinAttempted.current = false;
      } catch (error) {
        console.error('Disconnect failed:', error);
        addMessage(`Failed to disconnect: ${error.message}`, 'error');
      }
    }
  };

  const handleManualReconnect = async () => {
    try {
      addMessage('Manual reconnect requested', 'info');

      if (connection) {
        await disconnect();
      }

      await connectToSignalR();
    } catch (error) {
      console.error('Manual reconnect failed:', error);
      addMessage(`Manual reconnect failed: ${error.message}`, 'error');
    }
  };

  // Generic API call helper
  const makeApiCall = async (endpoint, data) => {
    try {
      setLastError1('');
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        throw new Error(errorData.error || `HTTP ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      const errorMsg = `API call failed: ${error.message}`;
      setLastError1(errorMsg);
      addMessage(`❌ ${errorMsg}`, 'error');
      throw error;
    }
  };

  // Join a group - Modified to accept groupName parameter for auto-join
  const joinGroup = async (groupName = null) => {
    const targetGroup = groupName || groupInput.trim();
    if (!targetGroup) {
      addMessage('⚠️ Please enter a group name', 'error');
      return;
    }

    try {
      const result = await makeApiCall('/alarmsSignalR/api/group/add', {
        userId: userId,
        groupName: targetGroup
      });
      
      setCurrentGroup(targetGroup);
      addMessage(`🚪 Joined group: ${targetGroup}`, 'success');
      
      // Only clear input if it was a manual join (not auto-join)
      if (!groupName) {
        setGroupInput('');
      }
      
      //await loadGroups(); // Refresh groups list
    } catch (error) {
      console.error('Failed to join group:', error);
    }
  };

  // Leave current group
  const leaveGroup = async () => {
    if (!currentGroup) {
      addMessage('⚠️ Not in any group', 'error');
      return;
    }

    try {
      await makeApiCall('/alarmsSignalR/api/group/remove', {
        userId: userId,
        groupName: currentGroup
      });
      
      addMessage(`🚪 Left group: ${currentGroup}`, 'success');
      setCurrentGroup('');
      //await loadGroups(); // Refresh groups list
    } catch (error) {
      console.error('Failed to leave group:', error);
    }
  };

  // Send message to group
  const sendMessageToGroup = async () => {
    if (!currentGroup) {
      addMessage('⚠️ Please join a group first', 'error');
      return;
    }

    const message = messageInput.trim();
    if (!message) {
      addMessage('⚠️ Please enter a message', 'error');
      return;
    }

    try {
      await makeApiCall('/alarmsSignalR/api/sendToGroup', {
        groupName: currentGroup,
        message: {
          text: message,
          sender: userId,
          timestamp: new Date().toISOString(),
          type: 'group'
        },
        targetMethod: 'ReceiveMessage'
      });
      
      addMessage(`📤 Sent to group ${currentGroup}: ${message}`, 'sent');
      setMessageInput('');
    } catch (error) {
      console.error('Failed to send message:', error);
    }
  };

  // Send message to specific user
  const sendMessageToUser = async () => {
    const targetUser = targetUserInput.trim();
    const message = messageInput.trim();
    
    if (!targetUser) {
      addMessage('⚠️ Please enter a target user ID', 'error');
      return;
    }

    if (!message) {
      addMessage('⚠️ Please enter a message', 'error');
      return;
    }

    try {
      await makeApiCall('/alarmsSignalR/api/sendToUser', {
        userId: targetUser,
        message: {
          text: message,
          sender: userId,
          timestamp: new Date().toISOString(),
          type: 'direct'
        },
        targetMethod: 'ReceiveMessage'
      });
      
      addMessage(`📤 Sent to user ${targetUser}: ${message}`, 'sent');
      setMessageInput('');
    } catch (error) {
      console.error('Failed to send message:', error);
    }
  };

  // Broadcast message
  const broadcastMessage = async () => {
    const message = messageInput.trim();
    if (!message) {
      addMessage('⚠️ Please enter a message', 'error');
      return;
    }

    try {
      await makeApiCall('/alarmsSignalR/api/broadcast', {
        message: {
          text: message,
          sender: userId,
          timestamp: new Date().toISOString(),
          type: 'broadcast'
        },
        targetMethod: 'ReceiveMessage'
      });
      
      addMessage(`📢 Broadcasted: ${message}`, 'sent');
      setMessageInput('');
    } catch (error) {
      console.error('Failed to broadcast message:', error);
    }
  };

  // Send legacy message (for backward compatibility)
  const sendLegacyMessage = async () => {
    const message = messageInput.trim();
    if (!message) {
      addMessage('⚠️ Please enter a message', 'error');
      return;
    }

    try {
      await makeApiCall('/alarmsSignalR/api/send', {
        message: message,
        userId: userId,
        target: 'messageReceived'
      });
      
      addMessage(`📤 Legacy message sent: ${message}`, 'sent');
      setMessageInput('');
    } catch (error) {
      console.error('Failed to send legacy message:', error);
    }
  };

  // Test SignalR connection
  const testSignalR = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/alarmsSignalR/api/test-signalr`);
      const result = await response.json();
      
      if (result.success) {
        addMessage(`✅ SignalR test successful - Token length: ${result.tokenLength}`, 'success');
      } else {
        addMessage(`❌ SignalR test failed: ${result.error}`, 'error');
      }
    } catch (error) {
      addMessage(`❌ SignalR test error: ${error.message}`, 'error');
    }
  };

  // Clear messages
  const clearMessages = () => {
    setMessages([]);
    setLastError1('');
  };
//ALERTS SPECIFIC IMPLEMENTATION END

  const getDeviceTagMappingcallback = (mapping) => {
    //console.log("Device Tag Mapping:", mapping);
    var mappingvar = mapping.data.data;
    settagDeviceMappings(mappingvar);
  };

  var usershortname = "";
  var splitname = username.split(" ");
  for (let i = 0; i < splitname.length; i++) {
    if (i < 2) {
      usershortname = usershortname + splitname[i][0];
    } else {
      break;
    }
  }
  const handleClick = (event) => {
    setAnchorE1(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorE1(null);
  };

  useEffect(() => {
  const handleRefreshLogout = () => {
    const username = sessionStorage.getItem("username");     // Or from Redux
    const projectId = sessionStorage.getItem("projectId");   // Or from Redux

    
    if (username) {
      navigator.sendBeacon("/logout", JSON.stringify({ username, projectId }));
    }
  };

  window.addEventListener("beforeunload", handleRefreshLogout);

  return () => {
    window.removeEventListener("beforeunload", handleRefreshLogout);
  };
}, []);

const handleLogout = async () => {
  try {
    // Get organizationId - check multiple possible locations
    const organizationId = 
      userdetails?.OrganizationID || 
      userdetails?.organizationId ||
      sessionStorage.getItem("organizationId");
    
    // Call with all three required parameters
    await userLogout(username, projectId, organizationId);

    dispatch(clearLoginData());
    sessionStorage.clear();
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
    navigate("/");
  } catch (error) {
    console.error("Logout failed:", error);
    // Still clear frontend even if API fails
    dispatch(clearLoginData());
    sessionStorage.clear();
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
    navigate("/");
  }
};

  const handleClosesnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpensnack(false);
  };

  const isEqual = (obj1, obj2) => {
    // console.log("obj1, obj2",JSON.stringify(obj1) === JSON.stringify(obj2))
    // if(JSON.stringify(obj1) === JSON.stringify(obj2)){
    //     console.log("JSON.stringify(obj1) === JSON.stringify(obj2) obj1",obj1,"JSON.stringify(obj1) === JSON.stringify(obj2) obj2",obj2)
    // }
    return obj1.id === obj2.id;
  };


  const [count, setCount] = useState(0);
  const countRef = React.useRef(0);

  const alarmrecordscallback = (datareceived) => {
    //console.log("alarmrecordscallback--datareceived",datareceived)
    dispatch(updatealarmarray(datareceived.data.data));
  };  

  const orgtreecallback = (res) => {
    dispatch(setOrganizationtree(res.data.treejson));
  };

   const handleKeyPress = (e, action) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      action();
    }
  };

  // Get message style based on type
  const getMessageStyle = (type) => {
    const baseStyle = 'p-3 mb-2 rounded-lg max-w-md break-words';
    switch (type) {
      case 'sent':
        return `${baseStyle} bg-blue-100 text-blue-800 ml-auto border-l-4 border-blue-500`;
      case 'received':
        return `${baseStyle} bg-green-100 text-green-800 border-l-4 border-green-500`;
      case 'group':
        return `${baseStyle} bg-purple-100 text-purple-800 border-l-4 border-purple-500`;
      case 'direct':
        return `${baseStyle} bg-yellow-100 text-yellow-800 border-l-4 border-yellow-500`;
      case 'error':
        return `${baseStyle} bg-red-100 text-red-800 border-l-4 border-red-500`;
      case 'warning':
        return `${baseStyle} bg-orange-100 text-orange-800 border-l-4 border-orange-500`;
      case 'success':
        return `${baseStyle} bg-green-100 text-green-800 border-l-4 border-green-500`;
      default:
        return `${baseStyle} bg-gray-100 text-gray-800 border-l-4 border-gray-400`;
    }
  };


  return (
    <Box className="header1">
      <img
        className="lauritz-knudsen-logo"
        src={LauritzKnudsenLogo}
        alt="Lauritz Kudsen"
      />
      <div style={{ flexGrow: 1 }}> </div>
      <img
        className="smartcomm-logo"
        src={SmartcommLogo}
        alt="Smartcomm Logo"
      />
      <div className="menu-icon">
        <MenuIconrounded sx={{ height: "18px", width: "18px" }} />
      </div>
      <Box className="profile">
        <Avatar
          className="user-icon"
          /*alt="User" src={User}*/ sx={{
            width: "36px",
            height: "36px",
            bgcolor: "var(--SecondaryBackground)",
            color: "var(--PrimaryText)",
            fontSize: "16px",
            fontWeight: 600,
          }}
        >
          {" "}
          {usershortname}{" "}
        </Avatar>
        <Tooltip
          title={username}
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "#005C8E",
                color: "#FFFFFF",
                borderRadius: "0px 0px 0px 10px",
                fontSize: "12px",
                fontWeight: 400,
                padding: "10px",
              },
            },
          }}
        >
          <Typography
            className="user-role"
            style={{
              fontSize: "16px",
              fontWeight: 400,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {" "}
            {username}{" "}
          </Typography>
        </Tooltip>
        <KeyboardArrowDownOutlinedIcon
          className="dropdown-icon user-role"
          style={{ marginLeft: "auto", marginRight: 0 }}
          onClick={handleClick}
        />
        <Menu
          anchorE1={anchorE1}
          open={Boolean(anchorE1)}
          onClose={handleClose}
          onClick={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{
            marginTop: "39px",
            "& .MuiMenu-paper": {
              width: "200px",
              backgroundColor: themechange === "dark" ? "#000000" : "#EFEFEF",
              color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
              borderRadius: "0px",
            },
          }}
        >
          {/* <MenuItem
            className="menu-list"
            style={{ fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LK_User
                color={themechange === "dark" ? "#FFFFFF" : "#3C3C3C"}
                width={"22px"}
                height={"22px"}
              />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {" "}
                Profile{" "}
              </Typography>
            </div>
          </MenuItem> */}
          {/* <MenuItem
            className="menu-list"
            style={{ fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
          > */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LK_Settings
                color={themechange === "dark" ? "#FFFFFF" : "#3C3C3C"}
                width={"22px"}
                height={"22px"}
              />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {" "}
                Settings{" "}
              </Typography>
            </div> */}
          {/* </MenuItem> */}
          <MenuItem
            className="menu-list"
            style={{ fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
            onClick={handleManualReconnect}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LK_Settings
                color={themechange === "dark" ? "#FFFFFF" : "#3C3C3C"}
                width={"22px"}
                height={"22px"}
              />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {" "}
                Reconnect SignalR{" "}
              </Typography>
            </div>
          </MenuItem>
          <MenuItem
            className="menu-list"
            style={{ fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
            onClick={handleLogout}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LK_LogOut
                color={themechange === "dark" ? "#FFFFFF" : "#3C3C3C"}
                width={"22px"}
                height={"22px"}
              />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {" "}
                Logout{" "}
              </Typography>
            </div>
          </MenuItem>
          {/* <MenuItem
            className="menu-list"
            style={{ fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
            // onClick={handleLogout}
          > */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LK_File
                color={themechange === "dark" ? "#FFFFFF" : "#3C3C3C"}
                width={"22px"}
                height={"22px"}
              />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {" "}
                Help File{" "}
              </Typography>
            </div> */}
          {/* </MenuItem> */}
          <MenuItem
            onClick={(e) => {
              e.preventDefault(); // Prevent default behavior
              e.stopPropagation(); // Prevent the menu from closing
            }}
            className="menu-list"
            style={{ fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
            // onClick={handleLogout}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LightModeOutlinedIcon
                color={themechange === "dark" ? "#FFFFFF" : "#3C3C3C"}
                width={"22px"}
                height={"22px"}
              />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  fontWeight: 600,
                  marginRight: "30px",
                }}
              >
                {" "}
                Dark Mode{" "}
              </Typography>
              <ConfigProvider
                theme={{
                  token: {
                    //colorBgContainer:'#000000',
                    motionDurationMid: "0.2s",
                    borderRadius: "20px",
                    colorPrimary: "#005C8E",
                    colorSecondary: "#000000",
                  },
                  components: {
                    Switch: {
                      //borderColor:'var(--SecondaryText)',
                      //trackBg:'#ffffff',
                      trackHeight: "20px",
                      trackMinWidth: "40px",
                      handleShadow: "0px",
                      handleBg: themechange == "light" ? "#EFEFEF" : "#E0E0E0",
                      handleSize: 12,
                      trackPadding: 4,
                    },
                  },
                }}
              >
                <AntdSwitch
                  value={toggleval}
                  defaultChecked={false}
                  onChange={handlethemetoggel}
                />
              </ConfigProvider>
            </div>
          </MenuItem>
          <MenuItem
            className="menu-list"
            style={{ fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
            onClick={() => setPopup(true)}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LK_Info
                color={themechange === "dark" ? "#FFFFFF" : "#3C3C3C"}
                width={"22px"}
                height={"22px"}
              />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                {" "}
                About{" "}
              </Typography>
            </div>
          </MenuItem>
        </Menu>
      </Box>
      {/*<Snackbar 
                anchorOrigin = {{vertical: 'top', horizontal: 'center'}}
                open={opensnack} 
                autoHideDuration={3000} 
                onClose={handleClosesnackbar}
                //message="New alert"
                sx={{border: '3px solid #FFFFFF', borderRadius: '100px',boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5)'}}
                style={{marginTop: '110px'}}
            >
                <Alert
                    onClose={handleClosesnackbar}
                    icon={<ErrorOutlineOutlinedIcon fontSize="inherit" style={{height: '40px', width: '40px', color: alarmcolor === '#FFD000' ? '#3C3C3C' : '#FFFFFF'}}/>}
                    //severity="success"
                    action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={handleClosesnackbar}
                        >
                          <CloseIcon fontSize="inherit" style={{height: '18px', width: '18px', color: alarmcolor === '#FFD000' ? '#3C3C3C' : '#FFFFFF'}}/>
                        </IconButton>
                    }
                    variant="filled"
                    sx={{ width: '100%', backgroundColor: alarmcolor }}
                    style={{height: '60px', borderRadius: '100px', display:'flex', alignItems:'center',alignContent: 'flex-start'}}
                >
                    <div style={{display:'flex', flexDirection: 'column', alignItems:'flex-start'}}>
                        <Typography style={{fontSize: '14px', fontWeight: 700, color: alarmcolor === '#FFD000' ? '#3C3C3C' : '#FFFFFF'}}> Alarm generated for Device 1 </Typography>
                        <Typography style={{fontSize: '12px', fontWeight: 400, color: alarmcolor === '#FFD000' ? '#3C3C3C' : '#FFFFFF'}}> Voltage exceded to 280 volts </Typography>
                    </div>
                </Alert>
            </Snackbar>
            */}
       {newalarms.map(
        (alarm, index) =>
          alarm && ( // Add null/undefined check for alarm
            <Snackbar
              key={index}
              open={openSnackbars[index]}
              onClose={handleCloseToast(index)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{
                height: "65px",
                border: "3px solid #FFFFFF",
                borderRadius: "150px",
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5)",
              }}
              style={{
                marginTop: "30px",
                backgroundColor:
                  alarm.AlertClass == "100"
                    ? "#DC272D"
                    : alarm.AlertClass == "75"
                    ? "#EE8C19"
                    : alarm.AlertClass == "50"
                    ? "#FFD000"
                    : "#00943D",
                color: "#FFFFFF",
              }}
            >
              <Alert
                onClose={handleCloseToast(index)}
                icon={
                  <ErrorOutlineOutlinedIcon
                    fontSize="inherit"
                    style={{
                      height: "40px",
                      width: "40px",
                      color: alarm.AlertClass == "50" ? "#3C3C3C" : "#FFFFFF",
                    }}
                  />
                }
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={handleCloseToast(index)}
                  >
                    <CloseIcon
                      fontSize="inherit"
                      style={{
                        height: "18px",
                        width: "18px",
                        color: alarm.AlertClass == "50" ? "#3C3C3C" : "#FFFFFF",
                      }}
                    />
                  </IconButton>
                }
                variant="filled"
                sx={{
                  width: "100%",
                  borderRadius: "150px",
                  backgroundColor:
                    alarm.AlertClass == "100"
                      ? "#DC272D"
                      : alarm.AlertClass == "75"
                      ? "#EE8C19"
                      : alarm.AlertClass == "50"
                      ? "#FFD000"
                      : "#00943D",
                  color: alarm.AlertClass == "50" ? "#3C3C3C" : "#FFFFFF",
                  "& .MuiAlert-icon": {
                    color: alarm.AlertClass == "50" ? "#3C3C3C" : "#FFFFFF",
                  },
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  alignContent: "flex-start",
                }}
              >
                {tagdetails[alarm?.TagID]?.Name +
                  " :  " +
                  alarm.TagValue}
              </Alert>
            </Snackbar>
          )
      )}
     
      {
        <Dialog
          maxWidth={"l"}
          open={popup}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              event.preventDefault();
            } else {
              handleClosePopup(event, reason);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            style: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
            },
          }}
          BackdropProps={{
            style: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                }}
              >
                <div style={{ flexGrow: 1 }}> </div>

                <div style={{ width: "8px", height: "8px" }}></div>
                <CustomCancelButton
                  buttonText={"Close"}
                  onClick={(event) => handleClosePopup(event, "closeButton")}
                />
              </div>
              <div style={{ backgroundColor: "#FFFFFF" }}>
                <table
                  width="100%"
                  style={{ textAlign: "left", padding: "0px", margin: "0px" }}
                >
                  <tr>
                    <td style={{ paddingBottom: "16px", paddingRight: "16px" }}>
                      <img
                        className="smartcomm-logo"
                        src={OperateLogo}
                        alt="Smartcomm Logo"
                      />
                    </td>
                    <td colSpan={2} style={{ paddingBottom: "16px" }}>
                      <CustomLabel labelText={"SmartComm Operate"} />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      <CustomLabel labelText={"Version: 1.0.1.0"} />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      <a
                        href="https://www.lk-ea.com/about/who-we-are/legal/privacy-policy"
                        className="newOption"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </>
          </DialogContent>
        </Dialog>
      }
    </Box>
  );
}

/*
<Alert
                    onClose={handleClosesnackbar}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                    style={{height: '70px', border: '3px soild #000000', borderRadius: '100px', display:'flex', alignItems:'center',alignContent: 'center'}}
                >
                    This is a success Alert inside a Snackbar!
                </Alert>
*/
